// src/utils/dateUtils.js

/**
 * Format a Date object into a custom string: "YYYY-MM-DD HH:mm:ss.SSS"
 * @param {Date} date
 * @returns {string}
 */
export function formatDateToCustom(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

/**
 * Given a date string or Date, returns a Mongo-style range object for tran_date:
 *   $gte = that day at 05:00:00.000
 *   $lte = next day at 04:59:00.000
 * both formatted as "YYYY-MM-DD HH:mm:ss.SSS"
 *
 * @param {string|Date} inputDate
 * @returns {{ tran_date: { $gte: string, $lte: string } }}
 */
export function getTransactionDateRange(inputDate) {
  const base = typeof inputDate === "string" ? new Date(inputDate) : inputDate;

  // Start at 05:00 of the given date
  const startTime = new Date(base);
  startTime.setHours(5, 0, 0, 0);
  const formattedStart = formatDateToCustom(startTime);

  // End at 04:59 of the next date
  const endTime = new Date(base);
  endTime.setDate(endTime.getDate() + 1);
  endTime.setHours(4, 59, 0, 0);
  const formattedEnd = formatDateToCustom(endTime);

  return {
    tran_date: {
      $gte: formattedStart,
      $lte: formattedEnd,
    },
  };
}
